import React from 'react';
import { useAppContext } from '../App';

const ProductGrid = ({ products }) => {
  const { handleProductClick } = useAppContext();

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div className="product-grid">
      {products.map((product, index) => (
        <div
          key={product.id}
          className="product-card"
          style={{ animationDelay: `${index * 0.05}s` }}
          onClick={() => handleProductClick(product)}
        >
          <div className="product-image">
            <img src={product.image} alt={product.name} />
            <div className="product-overlay">
              <button className="quick-view-btn">Quick View</button>
            </div>
          </div>
          <div className="product-content">
            <div className="product-header">
              <h3 className="product-name">{product.name}</h3>
              <span className="product-category">{product.category}</span>
            </div>
            <div className="product-details">
              <div className="detail-item">
                <span className="detail-label">CAS#</span>
                <span className="detail-value mono">{product.casNumber}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Purity</span>
                <span className="detail-value">{product.purity}</span>
              </div>
            </div>
            <div className="product-footer">
              <div className="product-supplier">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                  <polyline points="9 22 9 12 15 12 15 22" />
                </svg>
                {product.supplier}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductGrid;
